<template>
  <div class = "d-flex fd-column">
    <div v-on="isMobile && !showModal  ? { click: () => selectTimeFrame() } : {}" class="PANEL fd-column m-b-1 m-b-2:mo p-2 p-0:d">
      <div
          v-if="!isMobile"
          class="TITLE text-bold">
        Select Timeframe
      </div>
      <div class="d-flex fd-column-reverse:mo p-b-2:d">
        <div>
          <div class="d-flex">
            <div
                v-click-outside="closeDatePicker"
                @click="showPopover = true"
                class="custom-calendar"
            >
              <div>
                <div class="d-flex fd-row">
                  <div class="fd-column p-l-3:d">
                    <div class="text-bold LABEL ">Start Date</div>
                    <input
                        class="INPUT"
                        placeholder='mm/dd/yyyy'
                        v-model="displayRange.start"
                        @keyup="event => checkForValidDate(event.target.value, true)"
                    >
                  </div>
                  <div class="fd-column p-x-3:d p-l-3:mo">
                    <div class="text-bold LABEL">End Date</div>
                    <input
                        class="INPUT"
                        placeholder='mm/dd/yyyy'
                        v-model="displayRange.end"
                        @keyup="event => checkForValidDate(event.target.value, false)"
                    >
                  </div>
                </div>
              </div>
              <v-calendar
                  v-if="showPopover && !isMobile"
                  :attributes="attribs"
                  ref="calendar"
                  :model-config="modelConfig"
                  :value="dateRange"
                  color="depot"
                  @dayclick="modalDayClick"
                  class="POPOVER m-l-3:d"
                  :min-date='minDate'
                  :max-date="today"
              />
            </div>
          </div>
          <vk-modal v-if="showModal" @close="close">
            <vk-modal-body>
              <div class="d-flex text-center">
                <div @click="close" class="ARROW">
                  <vk-icon name="arrow-left" class="h1 p-2"/>
                </div>
                <div class="c-black w-100 MODAL-TITLE p-t-2">Select Timeframe</div>
              </div>
              <vk-modal-content>
                <div class="p-b-2 custom-calendar">
                  <div class="p-b-2">
                    <div class="d-flex fd-row">
                      <div class="fd-column p-l-3:d">
                        <div class="text-bold LABEL ">Start Date</div>
                        <input
                            class="INPUT"
                            placeholder='mm/dd/yyyy'
                            v-model="displayRange.start"
                            @keyup="event=>checkForValidDate(event.target.value, true)"
                        >
                      </div>
                      <div class="fd-column p-l-3">
                        <div class="text-bold LABEL">End Date</div>
                        <input
                            class="INPUT"
                            placeholder='mm/dd/yyyy'
                            v-model="displayRange.end"
                            @keyup="event=>checkForValidDate(event.target.value, false)"
                        >
                      </div>
                    </div>
                  </div>
                  <v-calendar
                      :attributes="attribs"
                      ref="modalCalendar"
                      :model-config="modelConfig"
                      :value="dateRange"
                      color="depot"
                      @dayclick="modalDayClick"
                      class="w-100"
                      :min-date='minDate'
                      :max-date="today"
                  />
                </div>
                <div>
                  <button class="btn btn-sm BUTTON" @click.prevent="handleClick">
                    Apply Filter
                  </button>
                </div>
              </vk-modal-content>
            </vk-modal-body>
          </vk-modal>
        </div>
        <div v-if="isMobile" class="as-end:t p-l-5:t p-b-2:mo">
          <button class="btn btn-sm BUTTON">Select Timeframe</button>
        </div>
        <div v-else class=" as-end:t p-l-2:t p-b-2:mo">
          <button
              class="btn btn-sm BUTTON"
              :disable="loading"
              @click.prevent="handleClick">
            Apply Filter
          </button>
        </div>
      </div>
    </div>
    <div class="PANEL d-flex fd-column">
      <div class="DATA-CONTAINER">
        <div class="DATA-ITEM-TITLE">
          {{jobStatusTitle}}
        </div>
        <div class="DATA-ITEM">
          New
          <div class="LEAD-NUMBER">{{newLeads}}</div>
        </div>
        <div class="DATA-ITEM">
          Potential
          <div class="LEAD-NUMBER">{{potentialLeads}}</div>
        </div>
        <div class="DATA-ITEM">
          Hired
          <div class="LEAD-NUMBER">{{hiredJobs}}</div>
        </div>
        <div class="DATA-ITEM">
          Completed
          <div class="LEAD-NUMBER">{{completedJobs}}</div>
        </div>
        <div class="DATA-ITEM">
          Archived
          <div class="LEAD-NUMBER">{{archivedLeads}}</div>
        </div>
        <div class="DATA-ITEM">
          Total
          <div class="LEAD-NUMBER">{{totalLeads}}</div>
        </div>
      </div>
      <history-items-list
          class="w-100"
          :historyJobs="jobEntries"
          :isMobile="isMobile"
          :hasSubmit="hasSubmit"
          :loading="loading"
      />
    </div>
  </div>
</template>
<script>
import http from '@homeservices/api-kit/axios';
import Calendar from 'v-calendar/lib/components/calendar.umd';
import { mapActions } from 'vuex';
import { format, isBefore, isAfter, isValid } from 'date-fns';
import HistoryItemsList from './components/HistoryItemsList';

export default {
  name: 'performance-history',
  components: {
    'v-calendar': Calendar,
    HistoryItemsList,
  },
  props: {
    closeIcon: {
      type: Boolean,
      default: true,
    },
  },
  data () {
    const today = new Date();

    return {
      loading: false,
      showModal: false,
      showPopover: false,
      minDate: new Date(1970, 0, 1),
      range: {
        start: null,
        end: null,
      },
      dateRange: null,
      displayRange: {
        start: null,
        end: null,
      },
      modelConfig: {
        type: 'string',
        mask: 'MM/DD/YYYY',
      },
      historyJobsWO: [],
      newHistoryJobs: {},
      historyJobs: {},
      today,
      hasSubmit: false,
      matchStatuses: {},
      jobEntries: [],
    };
  },
  computed: {
    attribs () {
      return [
        { highlight: {
          start: {
            style: {
              backgroundColor: '#F96302',
              borderRadius: '0px',
            },
            contentStyle: {
              color: '#ffffff',
            },
          },
          base: {
            style: {
              backgroundColor: this.range.start && this.range.end ? 'rgba(249,99,2,0.2)' : 'rgba(0,0,0,0.0)',
            },
          },
          end: {
            style: {
              backgroundColor: '#F96302',
              borderRadius: '0px',
            },
            contentStyle: {
              color: '#ffffff',
            },
          },
        },
        dates: { start: this.range.start, end: this.range.end },
        },
      ];
    },
    isMobile () {
      return this.$device.isMobileOrTablet;
    },
    jobStatusTitle () {
      return this.$device.isMobile ? 'Job status summary:' : 'Job status\nsummary:';
    },
    newLeads () {
      return this.matchStatuses.unreplied ? this.matchStatuses.unreplied : '-';
    },
    potentialLeads () {
      return this.matchStatuses.potential ? this.matchStatuses.potential : '-';
    },
    hiredJobs () {
      return this.matchStatuses.hired ? this.matchStatuses.hired : '-';
    },
    completedJobs () {
      return this.matchStatuses.completed ? this.matchStatuses.completed : '-';
    },
    passedLeads () {
      return this.matchStatuses.rejected ? this.matchStatuses.rejected : '-';
    },
    closedLeads () {
      return this.matchStatuses.closed ? this.matchStatuses.closed : '-';
    },
    cancelledLeads () {
      return this.matchStatuses.cancelledLeads ? this.matchStatuses.cancelledLeads : '-';
    },
    expiredLeads () {
      return this.matchStatuses.unresponsive ? this.matchStatuses.unresponsive : '-';
    },
    archivedLeads () {
      const archiveAllHypens = this.passedLeads === '-'
        && this.closedLeads === '-'
        && this.cancelledLeads === '-'
        && this.expiredLeads === '-';

      return archiveAllHypens ? '-' : (this.passedLeads !== '-' ? this.passedLeads : 0)
        + (this.closedLeads !== '-' ? this.closedLeads : 0)
        + (this.cancelledLeads !== '-' ? this.cancelledLeads : 0)
        + (this.expiredLeads !== '-' ? this.expiredLeads : 0);
    },
    totalLeads () {
      const totalAllHypens = this.newLeads === '-'
        && this.potentialLeads === '-'
        && this.hiredJobs === '-'
        && this.completedJobs === '-'
        && this.archivedLeads === '-';

      return totalAllHypens ? '-' : (this.newLeads !== '-' ? this.newLeads : 0)
        + (this.potentialLeads !== '-' ? this.potentialLeads : 0)
        + (this.hiredJobs !== '-' ? this.hiredJobs : 0)
        + (this.completedJobs !== '-' ? this.completedJobs : 0)
        + (this.archivedLeads !== '-' ? this.archivedLeads : 0);
    },
  },
  methods: {
    ...mapActions('dashboard/workOrderMatches', [
      'fetchWorkOrderMatches',
    ]),
    async getJobsHistory () {
      this.loading = true;
      this.historyJobs = {};
      this.newHistoryJobs = {};
      this.historyJobsWO = [];
      this.jobEntries = [];
      this.matchStatuses = {};
      await Promise.all([
        this.fetchHistoryWO(0),
        this.fetchHistory(0),
      ]);
      this.historyJobs = this.newHistoryJobs;
      this.orderJobs();
      this.loading = false;
    },
    async fetchHistoryWO (fromVal) {
      let totalJobs = 0;
      try {
        const { data } = await http.get('/platform/workorder/r/workorder/prorders/v1', {
          params: {
            start_date: format(new Date(this.range.start), 'yyyy-MM-dd'),
            end_date: format(new Date(this.range.end), 'yyyy-MM-dd'),
            size: 100,
            from: fromVal,
            with_aggregation: true,
          },
        }
        );
        this.matchStatuses = data.aggregation.match_statuses;
        this.historyJobsWO.push(...data.results);
        totalJobs = data.total;
      } catch (e) {
        console.error(e); // eslint-disable-line no-console
      }
      if (this.historyJobsWO.length < totalJobs) {
        await this.fetchHistoryWO(this.historyJobsWO.length);
      }
    },
    async fetchHistory (fromVal) {
      let totalJobs = 0;
      try {
        const { total, entities } = await this.fetchWorkOrderMatches({
          params: {
            start_date: format(new Date(this.range.start), 'yyyy-MM-dd'),
            end_date: format(new Date(this.range.end), 'yyyy-MM-dd'),
            from: fromVal,
            size: 100,
            sort: 'time_created desc',
          },
        });

        this.newHistoryJobs = { ...this.newHistoryJobs, ...entities.proWorkOrders };
        totalJobs = total;
      } catch (e) {
        console.error(e); // eslint-disable-line no-console
      }
      if (Object.keys(this.newHistoryJobs).length < totalJobs) {
        await this.fetchHistory(Object.keys(this.newHistoryJobs).length);
      }
    },
    selectTimeFrame () {
      this.range = { start: null, end: null };
      this.displayRange = { start: null, end: null };
      this.showModal = true;
    },
    modalDayClick (event) {
      const selectedDay = new Date(event.date);
      const start = this.range.start ? new Date(this.range.start) : null;
      const end = this.range.end ? new Date(this.range.end) : null;

      const displaySelectedDate = format(selectedDay, 'MM/dd/yyyy');

      if (isAfter(selectedDay, new Date())) {
        return;
      }
      if (!this.range.start) {
        this.range.start = selectedDay;
        this.displayRange.start = displaySelectedDate;
      } else if (!this.range.end) {
        this.range.end = selectedDay;
        this.displayRange.end = displaySelectedDate;
        if (isBefore(selectedDay, start)) {
          this.range.end = this.range.start;
          this.displayRange.end = format(this.range.start, 'MM/dd/yyyy');
          this.range.start = selectedDay;
          this.displayRange.start = displaySelectedDate;
        }
      } else if (isBefore(selectedDay, end) && isAfter(selectedDay, start)) {
        this.range.end = selectedDay;
        this.displayRange.end = displaySelectedDate;
      } else if (isBefore(selectedDay, end)) {
        this.range.start = selectedDay;
        this.displayRange.start = displaySelectedDate;
      } else if (isAfter(selectedDay, end)) {
        this.range.start = selectedDay;
        this.displayRange.start = displaySelectedDate;
        this.range.end = null;
        this.displayRange.end = null;
      }
    },
    checkForValidDate (text, isStartDate) {
      const calendar = this.isMobile ? this.$refs.modalCalendar : this.$refs.calendar;
      if (text.length === 0) {
        if (isStartDate) {
          this.range.start = null;
        } else {
          this.range.end = null;
        }
      }
      if (text.length === 10) {
        if ((!isValid(new Date(text)) || (isAfter(text, new Date())))) {
          if (isStartDate) {
            this.range.start = null;
            this.displayRange.start = null;
          } else {
            this.range.end = null;
            this.displayRange.end = null;
          }
        } else if (isStartDate) {
          this.range.start = text;
          calendar.move(text);
        } else if (isBefore(text, this.range.start)) {
          this.range.end = null;
          this.displayRange.end = null;
        } else {
          this.range.end = text;
          calendar.move(text);
        }
      }
    },
    closeDatePicker () {
      if (this.showPopover) {
        setTimeout(() => {
          this.showPopover = false;
        }, 200);
      }
    },
    close () {
      this.showModal = false;
    },
    mostAdvancedStatus (matches) {
      const MatchStatusRanking = {
        rejected: 0,
        closed: 1,
        unreplied: 2,
        accepted: 2,
        potential: 3,
        hired: 4,
        completed: 5,
      };

      let mostAdvanced = 'rejected';
      let currentStatusValue = 0;
      matches.every((aMatch) => {
        currentStatusValue = MatchStatusRanking[mostAdvanced.toLowerCase()];

        if (MatchStatusRanking.completed > currentStatusValue && aMatch.match_status.toLowerCase() === 'completed') {
          mostAdvanced = 'COMPLETED';
          return false;
        } if (MatchStatusRanking.hired > currentStatusValue && aMatch.match_status.toLowerCase() === 'hired') {
          mostAdvanced = 'HIRED';
        } else if (MatchStatusRanking.potential > currentStatusValue && aMatch.match_status.toLowerCase() === 'potential') {
          mostAdvanced = 'POTENTIAL';
        } else if (MatchStatusRanking.unreplied > currentStatusValue
            && (aMatch.match_status.toLowerCase() === 'unreplied' || aMatch.match_status.toLowerCase() === 'accepted')) {
          mostAdvanced = 'UNREPLIED';
        } else if (MatchStatusRanking.closed > currentStatusValue && aMatch.match_status.toLowerCase() === 'closed') {
          mostAdvanced = 'CLOSED';
        }
        return true;
      });
      return mostAdvanced.toLowerCase();
    },
    formatJobStatus (status) {
      if (status.toLowerCase() === 'unreplied' || status.toLowerCase() === 'accepted') {
        return 'new';
      } if (status.toLowerCase() === 'rejected') {
        return 'passed';
      }
      return status;
    },
    orderJobs () {
      this.jobEntries = this.historyJobsWO.map((job) => {
        const workOrder = this.historyJobs[job.order_hash];
        const filteredMatch = job.matches.filter(match => match.id === workOrder.matches);
        const obj = job;
        obj.current_status = this.formatJobStatus(this.mostAdvancedStatus(job.matches));
        obj.your_action = this.formatJobStatus(filteredMatch[0].match_status) || '';
        obj.lead_cost = filteredMatch[0].lead_cost || '';
        obj.work_order = workOrder;
        return obj;
      }
      );
    },
    handleClick () {
      if (((this.range.start && format(this.range.start, 'MM/dd/yyyy').length === 10)
          && (this.range.end && format(this.range.end, 'MM/dd/yyyy').length === 10))
          && !this.loading) {
        this.showPopover = false;
        this.showModal = false;
        this.getJobsHistory(0);
        this.$events.$emit(this.$events.HISTORY_APPLY_FILTER_CLICK);
        this.hasSubmit = true;
      } else {
        this.range = { start: null, end: null };
        this.displayRange = { start: null, end: null };
      }
    },
  },
};
</script>

<style lang="scss" scoped>
@import "~@homeservices/design-kit/tools";

.POPOVER {
  position: absolute;
  width: 34.5 * $unit;
}
.TITLE{
  font-size: 18px;
  padding: 2 * $unit 0px 1 * $unit 3 * $unit;

  @include mobile-only{
    padding: 2 * $unit 0px 2 * $unit 1.5 * $unit;
  }
}
.MODAL-TITLE {
  font-size: 18px;
}
.ARROW {
  position: absolute;
}

.DATA-ITEM-TITLE {
  padding: 5px $unit * 2 $unit * 2 $unit * 2;
  width: calc(40%);
  text-align: left;
  font-weight: bold;

  @include mobile-only{
    width: calc(100%);
  }
}
.DATA-ITEM {
  white-space: nowrap;
  padding: 0px $unit * 2 $unit * 2 $unit * 2;
  width: calc(33%);
}
.DATA-CONTAINER {
  display: flex;
  justify-content: space-around;
  text-align: center;
  background-color: #FFFFFF;
  border: 1px solid #CCCCCC;
  border-radius: 4px;
  padding-top: 2 * $unit;
  margin: 0px $unit * 4.25 $unit * 3.5 $unit * 4.25;
  font-size: 14px;

  @include mobile-only{
    margin: 0px;
    background-color: $color-gray20;
    border: none;
    justify-content: start;
    flex-direction: row;
    flex-wrap: wrap;
  }
}
.LEAD-NUMBER {
  font-size: 24px;
}
.PANEL {
  max-width: 1214px;
  display: flex;
  background-color: white;
  border: solid;
  border: 1px solid #CCCCCC;
  border-radius: 4px;
  margin-bottom: 8px;

  @include mobile-only {
    max-width: 95vw;
    max-height: 100%;
  }
  h3 {
    margin-bottom: 0;
  }
}
.BUTTON {
  min-width: 17.5 * $unit;
  @include mobile-only {
    min-width: 100%;
  }
}
.INPUT {
  position: initial;
  text-align: center;
  width: 15.75 * $unit;
  height: 5 * $unit;
  min-width: calc(50% );
   @include mobile-only {
      width: calc(100% );
   }
   &:active {
    outline-color: $color-depot;
  }
   &:focus-visible {
    outline-color: $color-depot;
  }
}
/deep/.custom-calendar {
  overflow:hidden;
  border-radius: 0;

  & .vc-container {
    --depot-100: #F96302;
    --depot-200: #f9630246;;
    --depot-300: #F96302;
    --depot-400: $color-gray80;
    --depot-500: #F96302;
    --depot-600: #F96302;
    --depot-700: #F96302;
    --depot-800: #F96302;
    --depot-900: $color-gray80;
    --rounded-full: 0;

  }
  & .vc-day-content{
    font-size: 16px;
  }
  & .vc-day-content:hover{
    background-color: rgba(0,0,0,.0);
  }
  & .vc-day-content:focus{
    background-color: rgba(0,0,0,.0);
  }
}
</style>
